import {
  EXCURSION_REPORT_FETCH_STARTED,
  EXCURSION_REPORT_FETCH_SUCCEEDED,
  EXCURSION_REPORT_FETCH_FAILED,
  EXCURSION_REPORT_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { fetchJson } from '#action/fetch';

export const fetchExcursionReport = (projectId, year, month) => async dispatch => {
  dispatch({ type: EXCURSION_REPORT_FETCH_STARTED });

  try {
    const url = webPortalApi.buildApiUrl(`report/excursion/${projectId}/${year}/${month}`);
    const data = await fetchJson(url);

    dispatch({
      type: EXCURSION_REPORT_FETCH_SUCCEEDED,
      payload: data
    });

    return { success: true, data };
  } catch (err) {
    dispatch({
      type: EXCURSION_REPORT_FETCH_FAILED,
      payload: err.message
    });

    return { success: false, error: err.message };
  }
};

export const clearExcursionReport = () => ({
  type: EXCURSION_REPORT_CLEAR
});
